import * as Yup from 'yup';
import { Activity, SpecificTarget } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Activity>().shape({
    name: Yup.string().nullable().required(),
    parent: Yup.object<SpecificTarget>().nullable().required(),
  });
}
